export default __webpack_public_path__ + "static/media/cryptoCardBg.89b7bd28.svg";